/* eslint-disable jsx-a11y/alt-text */
'use client'

import {
  Button,
  Chip,
  Image,
  Paragraph,
  Section,
  Title,
} from '@dynamo-caffeina-dev/airc-ui-kit'
import NextImage from 'next/image'

import {
  ButtonProps,
  ChipProps,
  NormalizedSection,
  ParagraphProps,
  RemappedCMSimageType,
  TitleProps,
} from '@/types'

import { QueryParamsWrapper } from '@/components/organisms/QueryParamsWrapper'
import {
  dispatchGTMEvent,
  GTM_EVENT_CATEGORY,
  GTM_EVENT_SECTION,
} from '@/helpers/gtm'

export interface HeroProps extends NormalizedSection {
  modelledContent?: {
    chip: ChipProps
    title: TitleProps
    paragraph: ParagraphProps
    button: ButtonProps
    image: RemappedCMSimageType
  }
}

const defaultModelledContent = {
  chip: {} as ChipProps,
  title: {} as TitleProps,
  paragraph: {} as ParagraphProps,
  button: {} as ButtonProps,
  image: {} as RemappedCMSimageType,
}

function Hero({ modelledContent = defaultModelledContent }: HeroProps) {
  const { chip, title, paragraph, button, image } = modelledContent
  const { fit, imageProps } = image

  const chipLabel = chip?.content
  const titleLabel = title?.content
  const paragraphContent = paragraph?.content
  const buttonLabel = button?.content

  const handleClickCapture = () => {
    dispatchGTMEvent(GTM_EVENT_CATEGORY.HERO_DONATION, {
      section: GTM_EVENT_SECTION.DONA_CTA_HERO,
    })
  }

  return (
    <Section className='section-hero'>
      <div className={'section-hero__content'}>
        <div className={'section-hero__content__text-wrap'}>
          {chipLabel ? (
            <Chip
              className='section-hero__content__text-wrap__chip'
              {...chip}
            >
              {chipLabel}
            </Chip>
          ) : null}
          {titleLabel ? (
            <Title
              {...title}
              className='section-hero__content__text-wrap__title'
              dangerouslySetInnerHTML={{ __html: titleLabel }}
            />
          ) : null}
          {paragraphContent ? (
            <Paragraph
              as={'div'}
              className='section-hero__content__text-wrap__paragraph'
              {...paragraph}
              dangerouslySetInnerHTML={{ __html: paragraphContent }}
            ></Paragraph>
          ) : null}
        </div>
        {buttonLabel && button.href ? (
          <QueryParamsWrapper>
            {(params) => {
              // TODO: make it generic function
              const hasUtmParams = params.has('utm_campaign')
              const linkHasParams = button.href ? new URL(button.href) : null

              const hasExistingUtmParams =
                linkHasParams?.searchParams.has('utm_campaign')

              const queryString =
                hasUtmParams || hasExistingUtmParams
                  ? `?${params.toString()}`
                  : ''
              const ctaLink = hasUtmParams
                ? `${linkHasParams?.origin}${linkHasParams?.pathname}${queryString}`
                : button.href

              return (
                <Button
                  {...button}
                  href={ctaLink}
                  variant={'themed'}
                  className='section-hero__content__button'
                  onClickCapture={handleClickCapture}
                >
                  {buttonLabel}
                </Button>
              )
            }}
          </QueryParamsWrapper>
        ) : null}
      </div>
      {imageProps?.src ? (
        <Image
          fit={fit}
          as={NextImage}
          className='section-hero__image'
          imageProps={{
            ...imageProps,
            // If not present (which it will not be,
            // since the CMS is not returning them),
            // it'll take the default value.
            // TODO find out why these props were expected here,
            // @ts-ignore
            width: imageProps.width || 400,
            // @ts-ignore
            height: imageProps.height || 400,
          }}
        />
      ) : null}
    </Section>
  )
}

export default Hero
